/**
 * * @module page/whatson.js
 */

import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";
import dotimeout from "../dotimeout";
import Filter from "../components/filter";

const Whatson = Backbone.View.extend({
  el: $(document),

  events: {
    "click .section-title .accordion-item-title-button": "openMainAccordion"
  },

  oldScroll: 0,

  initialize: function () {
    this.render();
  },

  setUpCollapsingSections: function(){
    if ($(window).width() < 769) {
      $("#section0").addClass("collapse").collapse("hide");
      $(".section .accordion-item-details")
        .addClass("collapse")
        .collapse("hide");
    } else {
      $(".section .accordion-item-details")
        .addClass("collapse")
        .collapse("show")
        .prev("button")
        .addClass("open");
    }
  },

  manageCollapsingSections: function(){
    $(".section .accordion-item-details").on("show.bs.collapse", function (e) {
      $(e.target).prev("button").addClass("open");
    });

    $(".section .accordion-item-details").on("hide.bs.collapse", function (e) {
      $(e.target).prev("button").removeClass("open");
    });
  },

  openMainAccordion: function(e){
    $("#section0").collapse("show");
    $(".section .accordion-item-details").collapse("show");
    $(e.target).hide();
    $(".filters-clear-button", $(e.target).parent().parent("h3")).show();

  },

  // followSection: function() {

  //   var _this = this;

  //   if ($(window).width() >= 769) {
      
  //     var element = $('.follow-scroll'),
  //       originalY = element.offset().top;

  //     // Space between element and top of screen (when scrolling)
  //     var topMargin = 20;

  //     // Should probably be set in CSS; but here just for emphasis
  //     element.css('position', 'relative');

  //     _this.oldScroll = 0;
  //     var scrollingBackUp = false;

  //     $(window).on('scroll', function (event) {

  //       var scrollTop = $(window).scrollTop();
  //       if (scrollTop < _this.oldScroll){
  //         //we're scrolling babck up
  //         scrollingBackUp = true;
  //       }

  //       if ($(".article-sidebar:hover").length == 0 || ($(".article-sidebar:hover").length == 1 && scrollingBackUp == true)) {

  //         element.stop(false, false).animate({
  //           top: scrollTop < originalY
  //             ? 0
  //             : scrollTop - originalY + topMargin
  //         }, 300);
  //       }

  //       _this.oldScroll = scrollTop;

  //     });
  //   }
  // },

  render: function () {
    this.filter = new Filter(".all-events-list .event-block", ".article-body .events");
    this.setUpCollapsingSections();
    this.manageCollapsingSections();
    // this.followSection();
  },
});

export default Whatson;

